import { inventoryBoxPublicOrigin } from "../inventory-box/inventory-box-url.js";

const ARRIVAL_PACKAGE_URL_PATTERN = /(?:^|\/)a\/([0-9a-f]{32})(?:[/?#]|$)/iu;

/** 32 hex characters from a package scan token. */
export function inboundArrivalPackageScanHex(scanToken: string): string {
  const compact = scanToken.trim().replaceAll("-", "").toLowerCase();
  if (!/^[0-9a-f]{32}$/.test(compact)) {
    throw new Error("scan_token must be a uuid.");
  }
  return compact;
}

/**
 * ECC200 payload: hub URL `/a/{32hex}`.
 * A phone camera opens the arrival page. Station scans still resolve the same token.
 * Origin follows unique-carton labels so a local API does not print localhost.
 */
export function buildInboundArrivalPackagePublicUrl(
  scanToken: string,
  origin = inventoryBoxPublicOrigin(),
): string {
  return `${origin.replace(/\/$/u, "")}/a/${inboundArrivalPackageScanHex(scanToken)}`;
}

export function inboundArrivalPackageScanPayload(scanToken: string): string {
  return buildInboundArrivalPackagePublicUrl(scanToken);
}

/**
 * Arrival package identity from a printed URL, a dashed UUID, or bare 32 hex.
 * A path that is not `/a/{hex}` is not an arrival token (inventory cartons use `/i/`).
 */
export function parseInboundArrivalPackageHex(raw: string): string | null {
  const trimmed = raw.trim();
  if (trimmed === "") return null;
  const fromUrl = trimmed.match(ARRIVAL_PACKAGE_URL_PATTERN)?.[1];
  if (fromUrl != null) return fromUrl.toLowerCase();
  if (trimmed.includes("/")) return null;
  const compact = trimmed.replace(/[\s-]/gu, "").toLowerCase();
  if (/^[0-9a-f]{32}$/u.test(compact)) return compact;
  return null;
}
